// Product Info Accordions
jQuery(document).ready(function(){
    $('h3.column__item__heading.h6').matchHeight();
});

//match home page featured categories  and what we value heights
jQuery(document).ready(function(){
  $('.column__item__text').matchHeight();
});

// Product Info Accordions
$(document).ready(function(){
  $(".pageButton-omni").click(function () {
    if ( $(this).is("#review-accordion") ) {
      $(this).closest(".pageButton-omni").toggleClass("active");
      $("#judgeme_product_reviews").parent().parent().parent().parent().slideToggle("fast");
    } else {
      $(this).next(".pagePanel-omni").slideToggle("fast");
      $(this).closest(".pageButton-omni").toggleClass("active");
    }
  });
});

//Jump to product reviews on star click
document.addEventListener("DOMContentLoaded", () => {
  let pdp_ratings_parent = document.getElementById('product-name-part');
  if ( pdp_ratings_parent ){
    let pdp_ratings = pdp_ratings_parent.querySelector('.product__rating');
    if ( pdp_ratings ) {
      pdp_ratings.addEventListener("click", () => {
        if ( !$("#review-accordion").closest(".pageButton-omni").hasClass("active") ) {
          $("#review-accordion").closest(".pageButton-omni").toggleClass("active");
          $("#judgeme_product_reviews").parent().parent().parent().parent().slideToggle("fast");
        }
        $("#review-accordion")[0].scrollIntoView({behavior: 'smooth'});
      });
    }
  }
});

//Move reviews to accordion after pageload
document.addEventListener("DOMContentLoaded", () => {
  let review_accordion = document.getElementById("review-accordion");
  let review_element_parent = document.getElementById("judgeme_product_reviews");
  if ( review_element_parent ) {
    let review_element = review_element_parent.parentElement.parentElement.parentElement.parentElement;
    if ( review_element_parent ) {
      review_element.style.display = 'none';
      if ( review_accordion && review_element ) {
        review_accordion.after(review_element);
      }
    }
  }
});

//set cookie on sign up form submit
$(document).ready(function(){
    $('#mc-embedded-subscribe-form').on('submit', function(){
      let CookieDate = new Date;
      CookieDate.setFullYear(CookieDate.getFullYear() +1);
      document.cookie = "custom-signup-used=user_has_closed; expires=" + CookieDate.toUTCString() + ';';
      // replace from with validation message
      document.querySelector(".mc-field-group-fname").remove();
      document.querySelector(".mc-field-group-lname").remove();
      document.querySelector(".mc-field-group-email").remove();
      document.getElementById('mce-success-response').before(document.querySelector(".mc-embed-subscribe-wrapper"));
      document.querySelector('.mc-embed-subscribe-wrapper').style.marginTop = "0px";
    });
});

//Hide signup form if it has been used before
let hide_form = document.cookie.match(/^(.*;)?\s*custom-signup-used\s*=\s*[^;]+(.*)?$/);

let sign_up_form = document.querySelector(".feedback-sign-up");
console.log(sign_up_form);
if ( hide_form ) {
  sign_up_form.classList.remove("popup--visible");
  sign_up_form.style.visibility = "hidden";
  console.log("hide form");
} else {
  console.log("don't hide form");
}
  


// B2B Bulk Order app (wopof) price formatting on /pages/b2b-multi-line-atc
// The app prints prices as "44 $" with a bogus struck-through compare-at next to them.
// Reformat to "$44" and hide the compare-at unless it is a real discount.
// The widget re-renders on search/sort/cart updates, so a MutationObserver reapplies the fix.
(function () {
  var root = document.getElementById('wopof-root');
  if (!root) return;

  var fixTimer = null;

  function formatPrice(text) {
    var m = (text || '').replace(/\u00a0/g, ' ').trim().match(/^([\d.,]+)\s*\$\s*$/);
    return m ? '$' + m[1] : null;
  }

  function parsePrice(text) {
    return parseFloat((text || '').replace(/[^\d.]/g, ''));
  }

  function fixWopofPrices() {
    // variant rows: "44 $   44 $" becomes "$44", compare-at hidden unless higher than the price
    root.querySelectorAll('.wopof-variant-price').forEach(function (wrap) {
      var orig = wrap.querySelector('.original_price');
      var comp = wrap.querySelector('.compare_at');
      if (!orig) return;
      var origVal = parsePrice(orig.textContent);
      var formatted = formatPrice(orig.textContent);
      if (formatted) orig.textContent = formatted;
      if (comp) {
        if (parsePrice(comp.textContent) > origVal) {
          var compFormatted = formatPrice(comp.textContent);
          if (compFormatted) comp.textContent = compFormatted;
        } else if (comp.style.display !== 'none') {
          comp.style.display = 'none';
        }
      }
    });
    // slide-out cart prices: "375 $" becomes "$375"
    root.querySelectorAll('.Line-item__price').forEach(function (el) {
      var formatted = formatPrice(el.textContent);
      if (formatted) el.textContent = formatted;
    });
    // order form footer: "Total: 375.00" + trailing " $ " span becomes "Total: $375.00"
    root.querySelectorAll('.wopof-selected-itemsCost-float').forEach(function (el) {
      var m = el.textContent.trim().match(/^Total:\s*([\d.,]+)$/);
      if (m) el.textContent = 'Total: $' + m[1];
    });
    root.querySelectorAll('.cur_symbol').forEach(function (el) {
      if (el.style.display !== 'none') el.style.display = 'none';
    });
  }

  // The product search input ships cramped (no padding, oversized text) and its
  // width is clamped by an app max-width rule that beats page CSS, so inline
  // styles are the only reliable override. Also fixes the placeholder typo.
  function fixSearchInput() {
    var input = root.querySelector('input[name="search_product"]');
    if (!input) return;
    if (input.placeholder !== 'Enter at least 3 chars') input.placeholder = 'Enter at least 3 chars';
    if (input.style.getPropertyValue('max-width') !== '180px') {
      input.style.setProperty('width', '180px', 'important');
      input.style.setProperty('max-width', '180px', 'important');
      input.style.setProperty('height', '40px', 'important');
      input.style.setProperty('padding', '10px', 'important');
      input.style.setProperty('font-size', '14px', 'important');
    }
  }

  new MutationObserver(function () {
    clearTimeout(fixTimer);
    fixTimer = setTimeout(function () {
      fixWopofPrices();
      fixSearchInput();
    }, 100);
  }).observe(root, { childList: true, subtree: true, characterData: true });

  fixWopofPrices();
  fixSearchInput();

  // Open the theme cart drawer instead of the app's own cart panel.
  // Capture phase stops the app's click handler from rendering its slide-out cart.
  // window.cart is the theme's CartDrawer instance; getCart() refreshes the drawer
  // contents from /cart.js so items the app added via AJAX show up.
  function openThemeCartDrawer() {
    if (window.cart) {
      window.cart.getCart();
      window.cart.openCartDrawer();
    } else {
      var themeCartToggle = document.querySelector('[data-cart-drawer-toggle]');
      if (themeCartToggle) themeCartToggle.click();
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('#wopof-root .cart')) return;
    e.preventDefault();
    e.stopPropagation();
    openThemeCartDrawer();
  }, true);

  // Open the theme cart drawer after the app's Add to cart finishes.
  // The app adds items with an XHR POST to /cart/add.js; a click on the Add to cart
  // button arms a flag and the drawer opens when that request completes successfully.
  var pendingCartOpen = false;
  var pendingCartOpenTimer = null;

  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('#wopof-root .add_all_to_cart')) return;
    pendingCartOpen = true;
    clearTimeout(pendingCartOpenTimer);
    pendingCartOpenTimer = setTimeout(function () { pendingCartOpen = false; }, 10000);
  });

  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._fsCartAdd = String(method).toUpperCase() === 'POST' && /\/cart\/add/.test(String(url));
    return xhrOpen.apply(this, arguments);
  };

  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._fsCartAdd) {
      this.addEventListener('load', function () {
        if (!pendingCartOpen || this.status < 200 || this.status >= 300) return;
        pendingCartOpen = false;
        clearTimeout(pendingCartOpenTimer);
        openThemeCartDrawer();
      });
    }
    return xhrSend.apply(this, arguments);
  };
})();

var darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
handleDarkmode(darkModeMediaQuery);
function handleDarkmode(e){
	var darkModeOn = e.matches; // true if dark mode is enabled
	var favicon = document.querySelector('link[rel="shortcut icon"]'); // get favicon-192.png element
	var largeFavicon = document.querySelector('link[rel="icon"]'); // get favicon.ico element
	if(!favicon || !largeFavicon){
		return; // where are our favicon elements???
	}
	// replace icons with dark/light themes as appropriate
	if(darkModeOn){
		favicon.href = '/favicon-dark.ico';
		largeFavicon.href = 'https://cdn.shopify.com/s/files/1/0721/9376/9770/files/Footer-logo-icon-black.png';
	}else{
		favicon.href = '/favicon.ico';
		largeFavicon.href = 'https://cdn.shopify.com/s/files/1/0721/9376/9770/files/Footer-logo-icon.png';
	}
}
darkModeMediaQuery.addListener(handleDarkmode);

// Quick Order category selector.
// 1) Top-level 3D buttons act as a tab/accordion: clicking one slides its panel open and
//    closes the others (clicking the active one closes it).
// 2) Clicking a collection card selects that collection in the Quik bulk-order app filter
//    (<select id="filters" class="header_filters">, option values are collection titles),
//    dispatches a change event so the list re-filters, and scrolls to the widget. It never
//    navigates away; if the app select is not ready yet it retries briefly.
(function () {
  var nav = document.querySelector('[data-qo-nav]');
  if (!nav) return;

  /* ---- Tabs / accordion ---- */
  var tabs = Array.prototype.slice.call(nav.querySelectorAll('.qo-nav__tab'));
  var panels = Array.prototype.slice.call(nav.querySelectorAll('.qo-nav__panel'));

  function panelFor(index) {
    return nav.querySelector('.qo-nav__panel[data-qo-panel="' + index + '"]');
  }

  function openTab(index) {
    tabs.forEach(function (tab) {
      var on = tab.getAttribute('data-qo-tab') === String(index);
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    panels.forEach(function (panel) {
      var on = panel.getAttribute('data-qo-panel') === String(index);
      panel.classList.toggle('is-open', on);
      if (on) {
        panel.removeAttribute('inert');
      } else {
        panel.setAttribute('inert', '');
      }
    });
  }

  function closeTab(index) {
    var tab = tabs.filter(function (t) { return t.getAttribute('data-qo-tab') === String(index); })[0];
    if (tab) {
      tab.classList.remove('is-active');
      tab.setAttribute('aria-expanded', 'false');
    }
    var panel = panelFor(index);
    if (panel) {
      panel.classList.remove('is-open');
      panel.setAttribute('inert', '');
    }
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var index = tab.getAttribute('data-qo-tab');
      if (tab.classList.contains('is-active')) {
        closeTab(index);
      } else {
        openTab(index);
      }
    });
  });

  /* ---- Collection card -> drive the Quik app filter ---- */
  function normalize(value) {
    return (value || '').toString().trim().toLowerCase().replace(/[\s\-–—]+/g, ' ');
  }

  function getCollectionSelects() {
    var selects = document.querySelectorAll('select#filters.header_filters, select.header_filters');
    return Array.prototype.filter.call(selects, function (sel) {
      // The collection filter is the one that includes an "all" option
      // (excludes the search-type Title/SKU/Tag select that shares the same id/class).
      return Array.prototype.some.call(sel.options, function (opt) {
        return opt.value === 'all';
      });
    });
  }

  function findOption(sel, title) {
    var exact = Array.prototype.filter.call(sel.options, function (opt) {
      return opt.value === title;
    })[0];
    if (exact) return exact;
    var target = normalize(title);
    return Array.prototype.filter.call(sel.options, function (opt) {
      return normalize(opt.value) === target || normalize(opt.textContent) === target;
    })[0];
  }

  function applySelection(title) {
    var matched = false;
    getCollectionSelects().forEach(function (sel) {
      var opt = findOption(sel, title);
      if (opt) {
        sel.value = opt.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        matched = true;
      }
    });
    return matched;
  }

  function selectCollection(title) {
    // Retry until the app's filter select exists (handles lazy app load).
    var attempts = 0;
    (function attempt() {
      if (applySelection(title)) return;
      if (attempts++ < 20) {
        setTimeout(attempt, 150);
      }
    })();
  }

  function scrollToApp() {
    var app =
      document.getElementById('wopof-root') ||
      document.querySelector('[id*="quik_quick_bulk_order"]');
    if (!app) return;
    var top = app.getBoundingClientRect().top + window.pageYOffset - 20;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  nav.addEventListener('click', function (event) {
    var card = event.target.closest('.qo-nav__card');
    if (!card || !nav.contains(card)) return;
    event.preventDefault(); // stay on the quick-order page; never follow the fallback link
    var title = card.getAttribute('data-qo-collection');
    if (!title) return;
    Array.prototype.forEach.call(nav.querySelectorAll('.qo-nav__card.is-active'), function (el) {
      el.classList.remove('is-active');
    });
    card.classList.add('is-active');
    scrollToApp();
    selectCollection(title);
  });
})();

// Quick Order method switch.
// Two buttons toggle between the "Order Form" view (category nav + Quik browse widget)
// and the "CSV / Sheet Import" view (the #quick-order-container upload widget).
// The active view is a class on <html> (qo-view-order | qo-view-csv); the matching
// show/hide and active-button rules live in assets/insight-custom-styles.css. The default
// class is set inline by section-quick-order-toggle.liquid so there is no flash on load.
(function () {
  var switcher = document.querySelector('[data-qo-switch]');
  if (!switcher) return;

  var tabs = Array.prototype.slice.call(switcher.querySelectorAll('.qo-switch__tab'));
  var root = document.documentElement;

  function setView(view) {
    root.classList.remove('qo-view-order', 'qo-view-csv');
    root.classList.add('qo-view-' + view);
    tabs.forEach(function (tab) {
      tab.setAttribute('aria-selected', tab.getAttribute('data-qo-view') === view ? 'true' : 'false');
    });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var view = tab.getAttribute('data-qo-view');
      if (!view || tab.getAttribute('aria-selected') === 'true') return;
      setView(view);
    });
  });
})();
